import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default class TableHeaderSort extends Component {
    static propTypes = {
        sort: PropTypes.object,
        columnName: PropTypes.string.isRequired,
        handleSort: PropTypes.func
    };

    setSort = () => {
        const { columnName, handleSort, sort: { firstField : currentName, firstOrder } } = this.props;
        const isNew = columnName !== currentName;

        const sorting = {
            firstField: columnName,
            firstOrder: isNew ? 'dec' : 'inc'
        };

        const shouldReset = !isNew && firstOrder === 'inc';
        handleSort(shouldReset ? {} : sorting);
    }

    render() {
        const { sort: { firstField, firstOrder}, columnName } = this.props;

        const isCurrent = firstField === columnName;
        const classes = cx(
            'table-sort',
            {'table-sort-desc': isCurrent && firstOrder === 'dec'},
            {'table-sort-asc': isCurrent && firstOrder === 'inc'}
        );

        return (
            <div className={classes} onClick={this.setSort} />
        );
    }
}
